import React from "react";
import ReactDOM from "react-dom/client";
import "./channel";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "sonner/dist/styles.css";
import "@/index.css";
import App from "@/App";
import { ModalCenter } from "@/modal_center";
import { registerPWA, InstallPWAButton } from "@/pwa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

registerPWA();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <React.Suspense fallback={<div style={{ padding: 24, fontFamily: "sans-serif", color: "#64748b" }}>Memuat…</div>}>
        <App />
      </React.Suspense>
      <ModalCenter />
      <InstallPWAButton />
      <Toaster position="top-center" richColors closeButton toastOptions={{ style: { fontFamily: '"Plus Jakarta Sans","Inter",sans-serif' } }}/>
    </QueryClientProvider>
  </React.StrictMode>,
);
